import { Pipe, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AsyncPipe } from '@angular/common';

@Pipe({
  name: 'timeAgo',
  pure:false
})
export class TimeAgoPipe extends AsyncPipe
{
    value:Date;
    timer:Observable<string>;

    constructor(ref:ChangeDetectorRef)
    {
        super(ref);
    }

    transform(obj:any):any
    {
        // if (obj instanceof Date)
        // {
        //     this.value = obj;

        //     if(!this.timer)
        //     {
        //         this.timer = this.getObservable();
        //     }

        //     return super.transform(this.timer);
        // }

        // return super.transform(obj);
        return obj;
    }

;

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_pipe/time-ago.pipe.ts